import styled from 'styled-components';
import { CALYPSO_DARK, LINK_HOVER } from 'HubStyleTokens/colors';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UILink from 'UIComponents/link/UILink';
/**
 * A component that looks like a link but is in fact not
 * This should be used in the context of a containing component which
 * is actually a link. Do not use this component in place of a real link!
 */

export const LikeLink = styled.span.withConfig({
  displayName: "AcademyLinks__LikeLink",
  componentId: "s63d5u-0"
})(["color:", ";cursor:pointer;font-weight:500;transition:all 0.15s ease-out;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;&:hover{text-decoration:underline;color:", ";}"], props => props.color || CALYPSO_DARK, props => props.hoverColor || LINK_HOVER);
export const RouterLink = styled(UIRouterLink).withConfig({
  displayName: "AcademyLinks__RouterLink",
  componentId: "s63d5u-1"
})(["font-weight:500;"]);
export const Link = styled(UILink).withConfig({
  displayName: "AcademyLinks__Link",
  componentId: "s63d5u-2"
})(["font-weight:500;"]);